module.exports = __webpack_public_path__ + "img/p_corte.db190721.jpg";